import React from 'react'
import update from 'immutability-helper';

import SpacesSelect from '../../../../../components/Spaces/SpacesSelect'

import { user } from '../../../../../core/controllers/user';
import { spacesUnitTest } from '../../../../../unittests/core/controllers/SpacesUnitTest';

export default class SpacesColorCodeUnitTest extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            vacantSpaceID: 0,
            occupiedSpaceID: 0,
            lateRentSpaceID: 0
        }
    }

    componentDidMount() {
    }

    componentWillUpdate(nextProps, nextState) {
    }

    testStateChanges() {
        spacesUnitTest.testStateChanges(this);
    }

    handleVacantSpaceSelect(e) {
        this.setState({
            vacantSpaceID: e.target.value
        })
    }

    handleOccupiedSpaceSelect(e) {
        this.setState({
            occupiedSpaceID: e.target.value
        })
    }

    handleLateRentSpaceSelect(e) {
        this.setState({
            lateRentSpaceID: e.target.value
        })
    }

    render(){
        return (
            <div class="col-md-8" style={{float:'right'}}>
                <div class="card">
                    <div class="header">
                        <h4 class="title"><i class="pe-7s-edit"></i> <small><i class="pe-7s-angle-right"></i></small> Color Coding Unit Test</h4>
                        <p class="category">Manually change the state of a space.  Simply choose a space from whatever state dropdown you would like to test and select "Test State Change".</p>
                    </div>
                    <div class="content">
                        <div class="row">
                            <div class="col-md-12">
                                <p class="category"><b>General</b></p>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label>Vacant Space</label>
                                    <SpacesSelect columnSize={12} onChange={this.handleVacantSpaceSelect.bind(this)}/>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label for="effective_date">Occupied Space</label>
                                    <SpacesSelect columnSize={12} onChange={this.handleOccupiedSpaceSelect.bind(this)}/>
                                    </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <p class="category"><b>Tenant(s)</b></p>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label>Late Rent</label>
                                    <SpacesSelect columnSize={12} onChange={this.handleLateRentSpaceSelect.bind(this)}/>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <button type="button" id="save-color-coding" data-loading-text="Loading..." class="add-tenant btn btn-info btn-fill pull-right" autoComplete="off" onClick={this.testStateChanges.bind(this)}>
                                    Test State Change
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
};


// WEBPACK FOOTER //
// app/unittests/components/Settings/Buildings/Spaces/SpacesColorCodeUnitTest.jsx